import styled from 'styled-components';
import tw from 'twin.macro';

import { CommonTextdecorationStyles } from '@/atoms/common';
import type { NeedlLinkType } from '@/router';
import { NeedlLink } from '@/router';
import type { CommonTextdecorationType } from '@/types';

export type RouterLinkType = CommonTextdecorationType &
  NeedlLinkType & {
    /**
     * should the link have underline by default
     */
    underline?: boolean;
  };

export const RouterLink = styled(NeedlLink)<RouterLinkType>(
  ({
    bold = false,
    color = 'gray',
    dark = false,
    size = 'sm',
    underline = false,
  }) => [
    underline && tw`underline hover:no-underline`,
    !underline && tw`no-underline hover:underline`,
    ...CommonTextdecorationStyles({ bold, color, dark, size }),
  ]
);
